import type { FC } from 'react';

import { Form } from '../../Form.tsx';
import type { GenericFormProps } from '../../GenericFormProps.ts';
import { Links } from './Links.tsx';
import { schema } from './schema.ts';

export const LinksForm: FC<GenericFormProps<typeof Links, typeof schema>> = ({
  onSubmit,
  buttonSlot,
  defaultValues,
}) => (
  <Form
    buttonSlot={buttonSlot}
    defaultValues={defaultValues}
    formContentElement={Links}
    schema={schema}
    onSubmit={onSubmit}
  />
);
